import { Routes } from '@angular/router';
import { PortalLayoutComponent } from './layouts/portal-layout/portal-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { Portalroutes } from './features-modules/portal/portal.routes';
import { Adminroutes } from './features-modules/admin/admin.routes';

export const routes: Routes = [
  // bloco do admin
  {
    path: 'admin',
    component: AdminLayoutComponent,
    children: [
      { path: '', redirectTo: 'estatisticas', pathMatch: 'full' },
      ...Adminroutes,
    ],
  },

  // bloco de auth
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () => import('./auth/components/login/login.component').then(m => m.LoginComponent)
      },
      {
        path: 'register',
        loadComponent: () => import('./auth/components/register/register.component').then(m => m.RegisterComponent)
      },
      {
        path: 'redefinir-senha',
        loadComponent: () => import('./auth/components/redefinir-senha/redefinir-senha.component').then(m => m.RedefinirSenhaComponent)
      }
    ]
  },

  // bloco do portal
  {
    path: '',
    component: PortalLayoutComponent,
    children: [
      { path: '', redirectTo: '', pathMatch: 'full' }, // só vale dentro do portal
      ...Portalroutes,
    ],
  },

  // fallback
  { path: '**', redirectTo: '' },
];
